// Created/Updated by Developer - 05/01/2024

import { Component } from '@angular/core'
import { BaseController } from './base.controller';

@Component({
	selector: 'av-vi12',
	template: `<div [id]="getId()" #target><div>`
})

export class AvVi12 extends BaseController {



	constructor() {
		super();
		super.setViewCode('AV_VI12');
	}

	ngOnDestroy(): void {
	}


	/* ---------------------- CONTROLLER LOGIC ------------------- */


		
	/* -------------------- END CONTROLLER LOGIC ----------------- */

}